import Vue from 'vue'
import App from './App.vue'
import VueI18n from 'vue-i18n'
import messages from './lang/index'
import router from './router'
import '@/styles/iconfont/iconfont.css'
import '@/styles/reset.css'
import '@/styles/index.less'
import '@/styles/fonts/stylesheet.css'
import '@/styles/animation.css'
import CollapseTransition from './static/js/collapse-transition'
import LazyImage from '@/components/lazyImg.vue'

// 全局注册组件
Vue.component('LazyImage', LazyImage)
Vue.component('CollapseTransition', CollapseTransition)
Vue.config.productionTip = false

Vue.directive('lazy', {
  inserted: function (el, binding) {
    function loadImage() {
      const rect = el.getBoundingClientRect()
      const isInViewport = rect.top < window.innerHeight && rect.bottom > 0
      
      if (isInViewport) {
        el.src = binding.value
        window.removeEventListener('scroll', loadImage)
      }
    }
    
    // 初始检查一次
    loadImage()
    
    // 添加滚动监听
    window.addEventListener('scroll', loadImage)
    
    // 保存函数引用以便移除
    el._lazyLoadHandler = loadImage
  },
  unbind: function (el) {
    if (el._lazyLoadHandler) {
      window.removeEventListener('scroll', el._lazyLoadHandler)
    }
  }
})

Vue.use(VueI18n)
const locale = localStorage.getItem('TV_LANGUAGE') ? localStorage.getItem('TV_LANGUAGE') : 'ru_RU'
const i18n = new VueI18n({
	messages,
	locale
})

new Vue({
	i18n,
	router,
	render: h => h(App),
}).$mount('#app')